import React from 'react';
export const useRefState = (initialValue) => {
    const [state, setState] = React.useState(initialValue);
    const reference = React.useRef(state);
    const setReferredState = (value) => {
        reference.current = value;
        setState(value);
    };
    return [reference.current, setReferredState, reference];
};
